import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CourseCards from './components/CourseCards';
import ConceptPages from './components/ConceptPages';
import Books from './components/Books';
import About from './components/About';
import Gallery from './components/Gallery';
import Practice from './components/Practice';
import Comparison from './components/Comparison';
import FAQ from './components/FAQ';
import Booking from './components/Booking';

export default function Home() {
  return (
    <main className="bg-background-50">
      <Navbar />
      <Hero />
      <CourseCards />
      <ConceptPages />
      <About />
      <Gallery />
      <Practice />
      <Comparison />
      <FAQ />
      <Books />
      <Booking />
      <Footer />
    </main>
  );
}